// Reicht das von Contao global geladene jQuery (Layout: addJQuery) als Modul
// durch, damit `import $ from 'jquery'` es nutzt statt eine zweite Kopie zu
// bundeln. Alias-Konfiguration siehe vite.config.js.
const $ = window.jQuery;

if (!$) {
  throw new Error('jQuery nicht gefunden — im Contao-Layout muss addJQuery aktiv sein.');
}

export default $;
export { $ as jQuery };
